import DOMHelper from 'utils/DOMHelpers';

/* eslint no-mixed-operators: 0 */

const scrollTo = (element, scrollToY, callback) => {
    const duration = 1000;
    const easing = pos => {
        if ((pos /= 0.5) < 1) {
            return 0.5 * Math.pow(pos, 4);
        }

        return -0.5 * ((pos -= 2) * Math.pow(pos, 3) - 2);
    };

    let scrollY = DOMHelper.getScrollPosition(element);
    let current = 0;
    let time = Math.max(0.1, Math.min(Math.abs(scrollY - scrollToY) / duration, 0.8));

    let tick = () => {

        current += 1 / 60;

        let p = current / time;

        if (p < 1) {
            window.requestAnimationFrame(tick);
            element.scrollTo(0, scrollY + (scrollToY - scrollY) * easing(p));
        } else {
            element.scrollTo(0, scrollToY);

            if (callback && typeof callback === 'function') {
                callback();
            }
        }

    };

    tick();
};

export default scrollTo;
